import Breadcrumbs from 'core/components/common/Breadcrumbs';
import CenterLoader from 'core/components/common/CenterLoader';
import NotFound from 'core/components/common/NotFound';
import { useLinks } from 'core/components/linksContext';
import injectSheet from 'core/style/injectSheet';
import { WithStyles } from 'core/style/interfaces';
import React from 'react';
import SocialShare from 'site/components/social-share/SocialShare';
import useLecturerData from './hooks/useLecturerData';
import Lecturer from './Lecturer';
import { styles } from './LecturersList';

const LecturerDetail: React.FC<WithStyles<typeof styles>> = ({ classes }) => {
    const links = useLinks();
    const [lecturer, loading] = useLecturerData();

    if (loading) {
        return <CenterLoader />;
    }

    // @see \src\site\components\product\public\productDetailFetchData.tsx
    if (!loading && !lecturer) {
        return <NotFound />;
    }

    const { account } = lecturer;

    return (
        <div className={classes.container}>
            <Breadcrumbs
                contrast={false}
                items={[
                    { href: links.teachers.url(), title: 'Преподаватели' },
                    {
                        href: links.teacherDetail.url(lecturer.id),
                        title: `${account.firstName} ${account.lastName}`,
                    },
                ]}
            />
            <div className={classes.content}>
                <div className={classes.lecturer}>
                    <Lecturer lecturer={lecturer} mode="DETAIL" style={{ marginBottom: 30 }} />
                    <SocialShare />
                </div>
            </div>
        </div>
    );
};

export default injectSheet(styles, 'LecturerDetail')(LecturerDetail);
